const __vite__mapDeps=(i,m=__vite__mapDeps,d=(m.f||(m.f=["./lenis-BNWJ7Zcm.css"])))=>i.map(i=>d[i]);
import { _ as __vitePreload } from "./preload-helper-BbOs9S9B.js";
import { s as scrollDispatcher, o as onScrollDirectionChange, a as onScrollUpdate, b as onPassedHeader, g as getScrollState } from "./scroll-dispatcher-BFP1rfBY.js";
const isSmoothScrollEnabled = document.body.dataset.ursusSmoothscroll === "true";
let lenis = null;
if (isSmoothScrollEnabled) {
  Promise.all([
    __vitePreload(() => import("./lenis-DM5hutOB.js"), true ? [] : void 0, import.meta.url),
    __vitePreload(() => Promise.resolve({}), true ? __vite__mapDeps([0]) : void 0, import.meta.url)
  ]).then(([{ default: Lenis }]) => {
    lenis = new Lenis({
      lerp: 0.25,
      smoothWheel: true,
      autoRaf: true,
      syncTouch: false
    });
    lenis.updateClassName = function() {
    };
    lenis.cleanUpClassName = function() {
    };
    scrollDispatcher.setLenis(lenis);
    if (typeof Theme !== "undefined") {
      Theme.lenis = lenis;
    }
    window.dispatchEvent(new CustomEvent("lenis:ready", {
      detail: { lenis, scrollDispatcher, isSmoothScrollEnabled: true }
    }));
  });
} else {
  window.dispatchEvent(new CustomEvent("lenis:ready", {
    detail: { lenis: null, scrollDispatcher, isSmoothScrollEnabled: false }
  }));
}
scrollDispatcher.init();
if (typeof Theme !== "undefined") {
  Theme.lenis = lenis;
  Theme.scrollDispatcher = scrollDispatcher;
  Theme.onScrollDirectionChange = onScrollDirectionChange;
  Theme.onScrollUpdate = onScrollUpdate;
  Theme.onPassedHeader = onPassedHeader;
  Theme.getScrollState = getScrollState;
  Theme.getScrollDirection = () => scrollDispatcher.getState().direction;
}
